<template>
  <common-panel
    class="marketing-tool-container"
    title="营销工具"
    :isShowPaddingTop="false"
    :paddingBottomVal="panelPaddingBottom"
  >
    <a-tabs default-active-key="0" :animated="false">
      <template v-for="(v, index) in paneList">
        <a-tab-pane :tab="v.tabname" :key="'' + index">
          <div class="each-content">
            <template v-for="(cItem, cIndex) in v.tabcontent">
              <div class="w-item" :key="'content' + cIndex">
                <div class="tool-item" v-if="cItem.title !== '更多'">
                  <img :src="cItem.icon" alt="">
                  <span class="title">{{cItem.title}}</span>
                  <span class="desc">{{cItem.desc}}</span>
                  <span class="button" @click="goLink(cItem.link)">查看详情</span>
                </div>
                <div class="tool-more" @click="goMore(cItem.link)" v-if="cItem.title === '更多'">
                  <img src="@/assets/images/add.png" alt="">
                  <span>更多></span>
                </div>
              </div>
            </template>
          </div>
        </a-tab-pane>
      </template>
    </a-tabs>
  </common-panel>
</template>

<script>
import CommonPanel from "@/components/common-panel/index"
import { Tabs } from 'ant-design-vue'
import { mapState } from 'vuex'
import _ from 'lodash'
const { TabPane } = Tabs
export default {
  props: {
    panelPaddingBottom: {
      type: String,
      default: '20px'
    }
  },
  components: {
    CommonPanel,
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane
  },
  computed: {
    ...mapState(['cmsConfig']),
    paneList () {
      let mtlist = this.cmsConfig.marketingTools
      // 计算tab页签分组内容
      if (Array.isArray(mtlist) && mtlist.length > 0) {
        let linkmore = null
        let tabNames = new Set(['全部'])
        mtlist.forEach(item => {
          if(item.title === '更多' && item.link && mtlist.length >= 8) {
            linkmore = item
          }
          let tabNameArr = item.tabName !== '' ? item.tabName.split('|') : ['全部']
          tabNameArr.forEach(tab => {
            tabNames.add(_.trim(tab))
          })
        })
        let tabs = []
        let tabNamesArr = [...tabNames]
        let fixedMtList = mtlist.filter(mt => mt.title !== '更多')
        // UI要求每个tab页最多只展示8个
        let firstTab = {
          tabname: '全部',
          tabcontent: linkmore !== null ? _.take(fixedMtList, 7).concat([linkmore]) : _.take(fixedMtList, 8)
        }
        tabs.push(firstTab)
        tabNamesArr.forEach(tabname => {
          if(tabname !== '全部') {
            let currentContent = fixedMtList.filter(item => item.tabName.includes(tabname))
            tabs.push({
              tabname,
              tabcontent: _.take(currentContent, 8)
            })
          }
        })
        return tabs
      }
      return []
    }
  },
  methods: {
    goLink(link) {
      if (!link) return
      window.open(link)
    },
    // 跳转更多
    goMore (link) {
      window.open(link)
    }
  }
}
</script>

<style lang="scss" scoped>
.each-content {
  display: flex;
  width: 100%;
  flex-wrap: wrap;
}
.w-item {
  width: calc((100% - 30px)/4);
  display: flex;
  margin-right: 10px;
}
.w-item:nth-child(4n+4) {
  margin-right: 0px;
}
.tool-item {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #F7F7F7;
  height: 180px;
  padding: 18px 20px 16px 20px;
  flex-shrink: 0;
  img {
    width: 44px;
    height: 44px;
    flex-shrink: 0;
    margin-bottom: 8px;
  }
  .title {
    font-family: MicrosoftYaHei-Bold;
    font-weight: bold;
    font-size: 14px;
    color: #333333;
    letter-spacing: 0;
    margin-bottom: 5px;
    flex-shrink: 0;
  }
  .desc {
    /* width: 110px; */
    font-family: MicrosoftYaHei;
    font-size: 12px;
    color: #666666;
    letter-spacing: 0;
    margin-bottom: 10px;
    flex-shrink: 0;
    height: 33px;
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
     word-break: break-all;
     text-align: center;
  }
  .button {
    width: 70px;
    height: 28px;
    border: 1px solid #1C7AE5;
    border-radius: 3px;
    font-family: MicrosoftYaHei;
    font-size: 12px;
    color: #1C7AE5;
    letter-spacing: 0;
    line-height: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    cursor: pointer;
  }
}
.tool-item:nth-child(-n + 4) {
  margin-bottom: 10px;
}
.tool-item:nth-child(n + 5) {
  margin-bottom: 20px;
}
.tool-more {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #F7F7F7;
  height: 180px;
  padding: 62px 51px 65px 51px;
  cursor: pointer;
  img {
    width: 30px;
    height: 30px;
    flex-shrink: 0;
    margin-bottom: 6px;
  }
  span {
    font-family: MicrosoftYaHei;
    font-size: 13px;
    color: #666666;
    letter-spacing: 0;
    white-space: nowrap;
  }
}
</style>
